import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";

const CustomSwitch = styled(Switch)(() => ({
  padding: 8,
  "& .MuiSwitch-switchBase": {
    "&.Mui-checked": {
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#E2772E", // checked track color
      },
    },
    "&.Mui-disabled": {
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#435B6D7A", // disabled track color
      },
    },
  },
  "& .MuiSwitch-track": {
    borderRadius: 11,
    backgroundColor: "#5B6D7A", // unchecked track color
    opacity: 1,
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 16,
    height: 16,
    margin: 2,
    color: "#FFF",
  },
}));

export default CustomSwitch;
